import { render, staticRenderFns } from "./SettlementForm.vue?vue&type=template&id=b39ca7b6&scoped=true"
import script from "./SettlementForm.vue?vue&type=script&lang=js"
export * from "./SettlementForm.vue?vue&type=script&lang=js"
import style0 from "./SettlementForm.vue?vue&type=style&index=0&id=b39ca7b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39ca7b6",
  null
  
)

export default component.exports